import NtunaCTA from "../reusables/NtunaCTA";

const SolutionsNtunaCTA = () => {
  return (
    <div className="section-spacing-80 no-padding-top">
      <NtunaCTA />
    </div>
  );
};

export default SolutionsNtunaCTA;    
